module.exports = __webpack_public_path__ + "media/newstyle/images/icon-arrow-down-purple-white-64cccb6bc79e5435babbb355fa601098.svg";